import React from 'react'
import ImageSlider from './ImageSlider'


const UserManual = () => {
  return (
    <>
  <ImageSlider />
    </>
  )
}

export default UserManual
